document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.media-rolling-text .rolling-text');
  if (!items.length) return;

  let index = 0;

  setInterval(() => {
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, 5500); // 5.5 seconds
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.code-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const code = this.dataset.code;
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const prompt = document.createElement('div');
        prompt.className = 'confirm-prompt';
        prompt.textContent = 'Copied to Clipboard!';
        document.body.appendChild(prompt);

        setTimeout(() => {
          prompt.remove();
        }, 2000);
      });
    });
  });

  document.querySelectorAll('.main_menu_cu').forEach(function(elem){
    elem.onclick = function(){
      let target = elem.getAttribute('data-target');
      elem.closest('.mega-menu__nav_inner').querySelector('.main_menu_cu.active').classList.remove('active');
      elem.closest('.mega-menu__nav_inner').querySelector('.sub_menu_cu.active').classList.remove('active');
      elem.closest('.mega-menu__nav_inner').querySelector('[data-menu-item="'+target+'"]').classList.add('active');
      elem.classList.add('active');
    }
  });

  document.querySelectorAll('.mobile-tab-btn').forEach(function(elem){
    elem.onclick = function(){
      let target = elem.getAttribute('data-tab');
      elem.closest('.mobile-tabs').querySelector('.mobile-tab-btn.is-active').classList.remove('is-active');
      elem.closest('.mobile-tabs').querySelector('.mobile-tab-panel.is-active').classList.remove('is-active');
      elem.closest('.mobile-tabs').querySelector('.mobile-tab-panel#'+target).classList.add('is-active');
      elem.classList.add('is-active');
    }
  });
});
